import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TrackerService } from '@shared/services/tracker.service';
import frenchi18n from '@assets/i18n/fr.json';
import { PopinComponent } from '../popin/popin.component';

@Component({
  selector: 'app-close-authentication-tab-popin',
  templateUrl: './close-authentication-tab-popin.component.html',
  standalone: true,
  imports: [PopinComponent, TranslateModule],
})
export class CloseAuthenticationTabPopinComponent implements OnChanges {
  @Input() show = false;
  @Output() cancelEvent = new EventEmitter();
  @Output() continueEvent = new EventEmitter();

  constructor(private tracker: TrackerService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.show?.previousValue === false && changes.show.currentValue === true) {
      this.tracker.trackPage({ taggingPage: 'CLOSE_EXTERNAL_BANK_CONNECTION_TAB' });
    }
  }

  continue() {
    this.tracker.trackClick({
      taggingPage: 'CLOSE_EXTERNAL_BANK_CONNECTION_TAB',
      click: frenchi18n.continue,
    });
    this.continueEvent.emit('');
  }

  cancel() {
    this.tracker.trackClick({
      taggingPage: 'CLOSE_EXTERNAL_BANK_CONNECTION_TAB',
      click: frenchi18n.cancel,
    });
    this.cancelEvent.emit('');
  }
}
